var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"flex-shrink-0",attrs:{"color":_vm.statusChip.color,"dark":"","outlined":""}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(_vm._s(_vm.statusChip.icon))]),_vm._v(" "+_vm._s(_vm.statusChip.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }